import { Typography } from "@mui/material"

export default function PoolNotFound() {
  return <Typography variant="h4">404 - Pool not found</Typography>
}
